import { useState } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import './style.scoped.css';
import TabBar from 'src/components/TabBar';
import i18n from 'src/lang/i18n';
import ProductTabContent from './ProductTabContent';
import homeStore, { HomeStore } from 'src/stores/HomeStore';
import { observer } from 'mobx-react-lite';
const tabData = [
  { name: i18n.t('main_product') },
  { name: i18n.t('supplementary_product') },
  { name: i18n.t('online_product') },
];

interface ProductListObserverProps {
  homeStore?: HomeStore;
}
const ProductListObserver = observer(
  ({ homeStore }: ProductListObserverProps) => {
    const { t } = useTranslation();
    const [tab, setTab] = useState<number>(0);

    const _handleChangeTab = (tabIndex: number) => {
      setTab(tabIndex);
    };

    const _renderContent = () => {
      if (tab == 0) {
        return (
          <ProductTabContent
            loadAction={homeStore.fetchMainProduct}
            productList={homeStore.mainProduct}
            loading={homeStore.loadingMainProduct}
            title={t('main_product')}
          />
        );
      } else if (tab == 1) {
        return (
          <ProductTabContent
            loadAction={homeStore.fetchSupportProduct}
            productList={homeStore.supportProduct}
            loading={homeStore.loadingSupportProduct}
            title={t('supplementary_product')}
          />
        );
      } else {
        return (
          <ProductTabContent
            loadAction={homeStore.fetchAllOnlineProduct}
            productList={homeStore.allOnlineProduct}
            loading={homeStore.loadingAllOnlineProduct}
            title={t('online_product')}
          />
        );
      }
    };

    return (
      <div className="screenContainerWithoutButton bg-primaryVariant">
        <Toolbar title={t('insurance_product')} type={'onPrimary'} />
        <div className="h-3" />
        <div className="px-4 pb-6">
          <TabBar
            data={tabData}
            activeTab={tab}
            onChangeTab={_handleChangeTab}
            scrollable={true}
          />
        </div>
        <div className="max-w-md mx-auto">{_renderContent()}</div>
      </div>
    );
  }
);

const ProductList = () => <ProductListObserver homeStore={homeStore} />;
export default ProductList;
